const SESSION_REPLAY_BE = `${window.location.origin}/api/v1/session_replay`;
const SESSION_REPLAY_BE_TTP = `${window.location.origin}/api/v1/ttp/session_replay`;
const MAX_RECORDING_TIME = 60 * 5;
var SessionReplayEventSection = /* @__PURE__ */ ((SessionReplayEventSection2) => {
  SessionReplayEventSection2["ON_CALL_AUTHORISE_POPUP"] = "on_call_session_replay_authorise_popup";
  SessionReplayEventSection2["ON_CALL_RECORDING_POPUP"] = "on_call_session_replay_recording_popup";
  SessionReplayEventSection2["USER_RESEARCH_AUTHORISE_POPUP"] = "user_research_session_replay_authorise_popup";
  return SessionReplayEventSection2;
})(SessionReplayEventSection || {});
var SessionReplayEventButton = /* @__PURE__ */ ((SessionReplayEventButton2) => {
  SessionReplayEventButton2["ON_CALL_AUTHORISE_REPLAY"] = "on_call_session_replay_authorise_btn";
  SessionReplayEventButton2["ON_CALL_FINISH_RECORDING"] = "on_call_session_replay_finish_recording_btn";
  SessionReplayEventButton2["ON_CALL_NO_AUTH"] = "on_call_session_replay_no_authorise_btn";
  SessionReplayEventButton2["USER_RESEARCH_AUTHORISE_REPLAY"] = "user_research_session_replay_authorise_btn";
  SessionReplayEventButton2["USER_RESEARCH_NO_AUTH_REPLAY"] = "user_research_session_replay_no_authorise_btn";
  return SessionReplayEventButton2;
})(SessionReplayEventButton || {});
const APP_ID_TO_RECORD_PROBABILITY = {
  4068: 1e-3,
  359713: 0.1,
  // ttspc
  5969: 0.5,
  // pearl
  474062: 0.5,
  // band_compass
  623948: 1
  // ux_insight_platform
};
var WINDOW_KEY = /* @__PURE__ */ ((WINDOW_KEY2) => {
  WINDOW_KEY2["STANDARD_RECORDER"] = "__GecSessionReplayStandardRecorder";
  WINDOW_KEY2["BLACKBOX_RECORDER"] = "__GecSessionReplayBlackboxRecorder";
  WINDOW_KEY2["BLACKBOX_RECORDER_INSTANCE"] = "__GecSessionReplayBlackboxRecorderInstance";
  WINDOW_KEY2["SAVE_BLACKBOX_RECORDING"] = "__GecSessionReplaySaveBlackboxRecording";
  WINDOW_KEY2["EXPERIMENTS"] = "__GecSessionReplayExperiments";
  return WINDOW_KEY2;
})(WINDOW_KEY || {});
export {
  APP_ID_TO_RECORD_PROBABILITY,
  MAX_RECORDING_TIME,
  SESSION_REPLAY_BE,
  SESSION_REPLAY_BE_TTP,
  SessionReplayEventButton,
  SessionReplayEventSection,
  WINDOW_KEY
};
